import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { WithdrawFeaturesStep } from '@/api/credit/types';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import useWithdrawMutation from '@/pages/Credit/hooks/useWithdrawMutation';
import Button from '@/ui-kit/components/Button/Button';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList/DataList';

type Payload = {
  withdrawal: WithdrawFeaturesStep;
};
type Props = ModalProps<Payload>;

const ConfirmWithdrawal = ({ payload, closeModal }: Props) => {
  const { t } = useTranslation(['Modal', 'Common']);
  const {
    withdrawal: { monthlyAmount, stepAmount, principalLeft, fees, period },
  } = payload;
  const { mutate: withdraw } = useWithdrawMutation();

  const handleClick = () => {
    withdraw(stepAmount);
    closeModal();
  };

  const hasNoFees = fees.setupFee === undefined && fees.withdrawalFee === undefined;

  return (
    <Modal title={t('ConfirmWithdrawal.title', { withdrawalAmount: stepAmount })}>
      <p>
        {!!hasNoFees && t('ConfirmWithdrawal.info')}
        {fees.setupFee !== undefined &&
          fees.withdrawalFee !== undefined &&
          t('ConfirmWithdrawal.infoWithFees', {
            withdrawalFee: fees.withdrawalFee,
            setupFee: fees.setupFee,
          })}
      </p>
      <DataList>
        <DataListItem>
          <DataListLabel>{t('ConfirmWithdrawal.infoTitle1', { numberOfInstallments: period })}</DataListLabel>
          <DataListValue>{t('Common:money', { amount: monthlyAmount })}</DataListValue>
        </DataListItem>
        <DataListItem>
          <DataListLabel>{t('ConfirmWithdrawal.infoTitle2')}</DataListLabel>
          <DataListValue>{t('Common:money', { amount: principalLeft })}</DataListValue>
        </DataListItem>
      </DataList>
      <ModalActions>
        <Button onClick={handleClick}>
          {t('ConfirmWithdrawal.button', { withdrawalAmount: stepAmount })}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default ConfirmWithdrawal;
